var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.brandCssClass,attrs:{"href":_vm.model.rootUrl}},[_c('img',{class:_vm.cssClass,attrs:{"src":_vm.logoUrl,"alt":_vm.model.brand}})])}
var staticRenderFns = []

export { render, staticRenderFns }